import { createFileRoute } from '@tanstack/react-router';

import { collectionDashboardScreen, dashboardSearch, loadCollectionMessages, loadCollectionScreens } from '@/modules/collection/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/gestao-carteira/recuperacao/')({
  validateSearch: dashboardSearch,
  staticData: { screen: collectionDashboardScreen },
  loader: () => loadCollectionMessages(),
  component: lazyScreen(loadCollectionScreens, 'CollectionDashboardRouteScreen'),
});
